export default "__VITE_ASSET__DBvvG6RH__"